<script setup>
import { onMounted, watch } from "vue";

import { useTokenManager } from "@/domain/Auth/application/useTokenManager";
// import { v4 as uuidv4 } from 'uuid';
import { useAuthStore } from "@/domain/Auth/infrastructure/stores/authStore";

// IMPORTS

// DEPENDENCIES
const authStore = useAuthStore();
const { startTokenMonitoring, stopTokenMonitoring } = useTokenManager();

// INJECT

// PROPS, EMITS

// REFS

// COMPUTED

// COMPONENT METHODS AND LOGIC
// const loadUsetifulScript = () => {
//   if (typeof window !== 'undefined' && typeof document !== 'undefined') {
//     window.usetifulTags = {
//       userId: uuidv4(),
//       firstName: "EXAMPLE_FIRST_NAME",
//       lastName: "EXAMPLE_LAST_NAME",
//     };

//     if (!document.getElementById('usetifulScript')) {
//       const script = document.createElement('script');
//       script.async = true;
//       script.src = 'https://www.usetiful.com/dist/usetiful.js';
//       script.id = 'usetifulScript';
//       script.dataset.token = 'bc8b5cec0517283966f79e8d812c9980';
//       document.head.appendChild(script);
//     }
//   }
// };

// PROVIDE, EXPOSE

// WATCHERS
// Start/stop monitoring based on auth status
watch(
  () => authStore.isAuthenticated,
  (isAuthenticated) => {
    if (isAuthenticated) {
      startTokenMonitoring();
    } else {
      stopTokenMonitoring();
    }
  },
  { immediate: true }
);

// LIFECYCLE METHODS (https://vuejs.org/api/composition-api-lifecycle.html)
onMounted(() => {
  // loadUsetifulScript();
});
</script>

<template>
  <router-view />
  <Toast />
  <ConfirmDialog />
  <ToastProvider />
</template>

<style scoped></style>
